'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const {currentPost, postsBasePath} = useLoadPostBySlug("2025/11/wcf-parc-national-tai");

    return (
        <PostContentFallback>
            <article>
                <div style={{ backgroundImage: `url(${currentPost?.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                        <SectionPage sectionType={"2xl"}>
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                        </SectionPage>
                    </div>
                </div>

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            Le 6 octobre 2025, Madame le Directeur Général a reçu le Dr Emmanuel Normand de la World Wide Fund for Nature (WWF), accompagnée de l’équipe technique de l’Office International pour la Protection de la Réserve de la Biosphère de Taï.
                        </p>

                        <p className="my-4 text-normal leading-relaxed font-semibold">
                            Objectifs de la rencontre :
                        </p>

                        <ul className="list-disc list-inside my-4 pl-4 text-normal">
                            <li>Échanger sur les actions de conservation de la biodiversité menées par la WWF</li>
                            <li>Explorer les opportunités de valorisation écotouristique du Parc national de Taï</li>
                            <li>Renforcer la coopération pour un tourisme durable en Côte d’Ivoire</li>
                        </ul>

                        <p className="my-4 text-normal leading-relaxed font-semibold">
                            Prospection sur le terrain :
                        </p>

                        <ul className="list-disc list-inside my-4 pl-4 text-normal">
                            <li>Une visite de prospection est prévue pour identifier les atouts touristiques et définir les axes prioritaires de développement.</li>
                        </ul>

                        <p className="my-4 text-normal leading-relaxed font-semibold">
                            Une ambition commune :
                        </p>

                        <ul className="list-disc list-inside my-4 pl-4 text-normal">
                            <li>Faire du Parc national de Taï une destination phare de l’écotourisme, alliant préservation de la biodiversité et développement touristique durable.</li>
                        </ul>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 4 }).map((_, index) => ({
                                    src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.jpg`,
                                    alt: `image${index + 1}`,
                                    width: 700,
                                    height: 700,
                                }))
                            } aspectRatio={"video"} />
                        </div>

                        <Tags tags={['ParcNationalDeTai', 'WCF', 'CôtedIvoire', 'Nature', 'Evasion', 'Tourisme', 'CôtedIvoireTourisme', 'OIPR', 'ParcsEtReserves']} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
